import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PolicyIntroduction from "./sections/PolicyIntroduction";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PolicyIntroduction />
      <Footer />
    </div>;
}